module.exports = __webpack_public_path__ + "img/glogo230.49c1dfb7.png";